import { render } from "./Cross.vue?vue&type=template&id=bac460bc"
const script = {}
script.render = render

export default script